import { render, staticRenderFns } from "./drawerProjectsTaskFlowClose.vue?vue&type=template&id=cfdf2f32&"
import script from "./drawerProjectsTaskFlowClose.vue?vue&type=script&lang=js&"
export * from "./drawerProjectsTaskFlowClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports